import { Text, View } from '@react-pdf/renderer';

// Utils
import { htmlToBulletLines, htmlToSpacedPlainText } from '@/utils/htmlSerializer';
import { buildDateRange, buildTechStackText, flattenJourneyProjects } from '@/utils/resume';
import { isEmptyValueArray } from '@shared/utils';

// Components
import BulletRow from './BulletRow';

// Tokens
import { SECTION_TITLES } from '@/components/template/resume/AgilityIO/tokens';

// Types
import { FormJourney } from '@shared/types';

// Styles
import styles from '../style';
interface ExperiencesSectionProps {
  journeys: FormJourney[];
}
const ExperiencesSection = ({
  journeys
}: ExperiencesSectionProps) => {
  if (!journeys || isEmptyValueArray(journeys)) return null;
  const allProjects = flattenJourneyProjects(journeys);
  if (isEmptyValueArray(allProjects)) return null;
  return <View style={styles.section} data-sentry-element="View" data-sentry-component="ExperiencesSection" data-sentry-source-file="Experiences.tsx">
      <Text style={styles.sectionHeading} data-sentry-element="Text" data-sentry-source-file="Experiences.tsx">{SECTION_TITLES.experience}</Text>

      {allProjects.map(({
      project,
      role
    }, projIdx) => {
      const {
        name: projectName = '',
        desc = '',
        duties = '',
        stacks = [],
        start = '',
        end = ''
      } = project || {};
      const duration = buildDateRange(start, end);
      const plainDesc = htmlToSpacedPlainText(desc);
      const bulletLines = htmlToBulletLines(duties);
      const techStackText = buildTechStackText(stacks ?? []);
      const projectNumber = projIdx + 1;
      return <View key={`proj-${projIdx}`}>
            {/* Project #N: projectName */}
            <Text style={styles.jobTitle}>
              {`Project #${projectNumber}${projectName ? `: ${projectName}` : ''}`}
            </Text>

            {plainDesc && <Text style={styles.entryMeta}>{plainDesc}</Text>}

            {duration && <Text style={styles.entryMeta}>
                <Text style={styles.bulletLabel}>{'Duration: '}</Text>
                {duration}
              </Text>}

            {role && <Text style={styles.entryMeta}>
                <Text style={styles.bulletLabel}>{'Role: '}</Text>
                {role}
              </Text>}

            {/* Responsibility / key-achievement bullets from duties */}
            {bulletLines.map((line, lineIdx) => <BulletRow key={`line-${projIdx}-${lineIdx}`} textStyle={styles.entryBulletText}>
                {line}
              </BulletRow>)}

            {/* Technical Skills bullet, per-project */}
            {techStackText && <BulletRow textStyle={styles.entryBulletText}>
                <Text style={styles.bulletLabel}>{'Technical Skills: '}</Text>
                {techStackText}
              </BulletRow>}

            {/* Entry gap between projects */}
            <View style={styles.entryGap} />
          </View>;
    })}
    </View>;
};
export default ExperiencesSection;